// =============================================================================
// RespondersPage.jsx — Resources → Responders (read-only, supervisor-authored)
// =============================================================================
// Content is authored under Manage → Resource Pages; rendered here as a nestable
// tree of pages via the shared ResourceSection. (db-109)
// =============================================================================

import { ResourceSection } from "./ResourceSection.jsx";

export function RespondersPage() {
  return <ResourceSection section="responders" heading="Responders" />;
}
